import { Img, Picture, Source } from '@xo-union/tk-component-picture';
import React, { type FunctionComponent } from 'react';
import Styles from '../../../styles.scss';
import type { ArticleDetails } from '../../../types';

export interface Props {
	article: ArticleDetails;
	trackClickThroughToContent: () => void;
}

export const ArticlePicture: FunctionComponent<Props> = (props: Props) => {
	const { article, trackClickThroughToContent } = props;

	return (
		<div className={Styles.article}>
			<a href={article.href} onClick={trackClickThroughToContent}>
				<Picture
					env="production"
					id={article.srcId}
					data-testid={article.srcId}
				>
					<Source viewport="xs" width={320} height={240} />
					<Source viewport="sm" width={385} height={288} />
					<Source viewport="md" width={460} height={345} />
					<Source viewport="lg" width={247} height={185} />
					<Source viewport="xl" width={307} height={230} />

					<Img
						alt={article.alt}
						className="lazyload"
						lazy
						height={345}
						width={460}
					/>
				</Picture>
			</a>
		</div>
	);
};
